import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {SpinnerBox} from './boxes/spinner/spinner.box';
import {SpinnerBrandBox} from './boxes/spinner-brand/spinner-brand.box';
import {SpinnerBackgroundBox} from './boxes/spinner-background/spinner-background.box';
import {SpinnerLogoBox} from './boxes/spinner-logo/spinner-logo.box';
import {CyClass} from '../../../common/cy-classes';

export const SpinnerComponent = observer(class SpinnerComponent extends OrbitComponent<{}> {


    render() {

        if(!this.services.spinner.isSpinning || this.services.routing.currentRoute.isOrbitRoute) {
            return null;
        }

        return (
            <SpinnerBox className={CyClass('cy-spinner')}>
                <SpinnerBrandBox className='cy-spinner-brand'>
                    <SpinnerBackgroundBox className='cy-spinner-background'/>
                    <SpinnerLogoBox className='cy-spinner-logo' isRTL={this.services.language.isRTLLanguage} />
                </SpinnerBrandBox>
            </SpinnerBox>
        );
    }
});
